// Mock API Delivery Types
// Надо убрать когда появится реальный тип
export const EAPIDeliveryType = {
  PICKUP: 'pickup',
  DELIVERY: 'delivery',
} as const;

export type TAPIDeliveryType = (typeof EAPIDeliveryType)[keyof typeof EAPIDeliveryType];
